"use client";

import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";

import Button from "@/components/Button/Button";
import ContactFormModal from "@/components/ContactFormModal/ContactFormModal";

import "./FeatureSliderSection.scss";

import "swiper/css";

const FeatureSliderSection = ({
  title,
  description,
  items = [],
  buttonText = "Talk With Us",
  showButton = true,
  sectionClass = "",
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className={`feature-slider-section ${sectionClass}`}>
      <Container>
        {/* Header */}
        <Row className="section-header align-items-center">
          <Col xxl={8} xl={6} lg={6} md={6}>
            <div className="text-wrapper">
              <h2 className="section-title">{title}</h2>
            </div>
          </Col>

          <Col xxl={4} xl={6} lg={6} md={6}>
            <div className="text-wrapper">
              <p className="section-description">{description}</p>
            </div>
          </Col>
        </Row>

        {/* Swiper */}
        <Row className="mt-4">
          <Col xs={12}>
            <Swiper
              modules={[Autoplay]}
              observer={true}
              observeParents={true}
              updateOnWindowResize={true}
              resizeObserver={true}
              loop={true}
              speed={3500}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              allowTouchMove={true}
              grabCursor={true}
              slidesPerView={1.2}
              spaceBetween={12}
              breakpoints={{
                480: {
                  slidesPerView: 1.5,
                  spaceBetween: 12,
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 2.5,
                  spaceBetween: 16,
                },
                992: {
                  slidesPerView: 3,
                  spaceBetween: 18,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 18,
                },
              }}
              className="feature-swiper"
            >
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="feature-card">
                    <div className="icon-box">
                      <Image
                        src={item.image}
                        alt={item.title}
                        width={32}
                        height={32}
                      />
                    </div>

                    <span className="feature-name">{item.title}</span>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>

        {/* CTA Button */}
        {showButton && (
          <div className="text-center">
            <Button
              variant="primary"
              size="lg"
              className="action-btn"
              onClick={() => setShowModal(true)}
            >
              {buttonText}
            </Button>
          </div>
        )}
      </Container>

      <ContactFormModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => setShowModal(false)}
      />
    </section>
  );
};

export default FeatureSliderSection;